export const validarRut = (rut) => {
    if (!rut) return true;
    const cleanRut = rut.replace(/[^0-9kK]/g, '');
    if (cleanRut.length < 2) return false;

    const body = cleanRut.slice(0, -1);
    const dv = cleanRut.slice(-1).toUpperCase();

    let suma = 0;
    let multiplo = 2;

    for (let i = body.length - 1; i >= 0; i--) {
        suma += multiplo * body.charAt(i);
        multiplo = (multiplo + 1) % 8 || 2;
    }

    const dvCalculado = 11 - (suma % 11);
    let dvFinal = dvCalculado === 11 ? '0' : dvCalculado === 10 ? 'K' : dvCalculado.toString();

    return dv === dvFinal;
};

export const formatearRut = (rut) => {
    let actual = rut.replace(/^0+/, "").replace(/[^0-9kK]/g, "");
    if (actual !== '' && actual.length > 1) {
        let an = actual.slice(0, actual.length - 1);
        let dv = actual.slice(actual.length - 1).toUpperCase();
        return an + "-" + dv;
    }
    return actual;
};